<template>
  <tr>
    <td>
      <b-form-input :disabled="readOnly" v-model="objTest.tipoEvaluacion" type="text"></b-form-input>
    </td>
    <td>
      <b-form-input :disabled="readOnly" v-model="objTest.programa" type="text"></b-form-input>
    </td>
    <td>
      <b-form-input :disabled="readOnly" v-model="objTest.anio" type="number"></b-form-input>
    </td>
    <td>
      <b-form-textarea :disabled="readOnly" v-model="objTest.estado"></b-form-textarea>
    </td>
    <td>
      <b-form-input :disabled="readOnly" v-model="objTest.monto" type="number"></b-form-input>
    </td>
    <td>
      <b-form-textarea :disabled="readOnly" v-model="objTest.link"></b-form-textarea>
    </td>
    <td>
      <b-form-textarea :disabled="readOnly" v-model="objTest.evaluacion"></b-form-textarea>
    </td>
    <td><i v-if="!readOnly" @click="removeItem(objTest)" class="bx bxs-trash"></i></td>
  </tr>
</template>
<script>
export default {
  props: ["removeItem", "objTest", "index", "readOnly"],
};
</script>
<style>
.controller-forms {
  font-size: 0.8rem !important;
  width: 100% !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.bxs-trash {
  font-size: 1.5rem;
  color: #25a2b7;
  cursor: pointer;
}
.input-fecha {
  width: 100% !important;
  border: none;
  border: 1px solid #ccc;
}

.input-fecha:focus {
  border: #24c6ab;
}
</style>
